import "./CrmList.css";
import { useGetCrmListQuery } from "./crmApiSlice"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { Popconfirm, message } from 'antd'
import { downloadFile } from "../utils/Utilities"
import { selectCurrentId } from "../auth/authSlice"

const CrmList = () => {
    const [crmList, setCrmList] = useState([])
    const [errorMessage, setErrorMessage] = useState("")
    const userId = useSelector(selectCurrentId)

    const {
        data,
        isLoading,
   } = useGetCrmListQuery(undefined, {
       pollingInterval: 60000,
       refetchOnFocus: true,
       refetchOnMountOrArgChange: true
   })

   useEffect(() => {
        if(data) {
            setCrmList(data.entities)
        }
    }, [data])

   const [messageApi, contextHolder] = message.useMessage()

   const alertMessage = (message) => {
       messageApi.success(message)
   }

   useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])   

   const navigate = useNavigate()
   const dispatch = useDispatch()

   const getTableData = () => {
    return crmList && Object.values(crmList).length > 0 ?
        Object.values(crmList).map(entity => {
            return (
            <tr onClick={() => navigate(`/dash/crm/${entity.id}`)}>
                <td>{entity.advisorName}</td>
                <td>{entity.lastUpdatedBy + " - " + entity.lastUpdatedByRole}</td>
                <td>{entity.lastUpdated}</td>
            </tr>
            )
        })
        :
        <p>No available data</p> 
   }

    return (
        <div className="table-page-container">
            {contextHolder}
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="table-container">
                <table className="file-table">
                    <tr>
                        <th>Advisor</th>
                        <th>Last Updated By</th>
                        <th>Last Updated</th>
                    </tr>
                    {getTableData()}
                </table>
            </div>
        </div>
    )
}

export default CrmList